import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQuery, useMutation } from 'react-apollo';
import { useToasts } from 'react-toast-notifications';
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import { map } from 'lodash';
import {
  Modal, ModalBody, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Input, Button,
} from 'reactstrap';
import moment from 'moment';
import {
  FALLBACK_ICON, capitalizeEveryWord, staticConstants, handleGraphqlError, dateFormats,
} from '../../utils';
import Demographics from '../admin/demographs/Demographics';
import { GET_ASSOCIATED_DATA_QUERY, GET_USER_DATA_QUERY, GET_GENRE } from '../../graphql-client/queries';
import { UPDATE_USER, LOADER_MUTATION } from '../../graphql-client/mutations';
import AssocoatedOffers from '../comps/AssociatedOffers';
import { Deactivate } from './index';
import EditProfileDetail from '../admin/manager/EditProfileDetail';

function ArtistDetail(props) {
  const {
    isOpen, onClose, updateUserList, userId, canEdit, isCurrentUserDeactive, canNavToOffer,
  } = props;
  const { addToast } = useToasts();
  const [modal, setModal] = useState(isOpen);
  const [deactivateModal, setDeactivateModal] = useState();
  const [editArtistModal, setEditArtistModal] = useState();
  const [noteValue, setNoteValue] = useState('');
  const [defaultNoteValue, setDefaultNoteValue] = useState('');
  const [isEditDemoGraph, setIsEditDemoGraph] = useState(false);
  const [isDemoGraphExist, setIsDemoGraphExist] = useState(false);
  const [graphLastUpdatedAt, setGraphLastUpdatedAt] = useState();
  const [userData, setUserData] = useState(false);
  const targetref = React.createRef();

  const [loaderMutate] = useMutation(LOADER_MUTATION);
  const { data: generData } = useQuery(GET_GENRE);

  const genreData = generData && generData.getGenre && generData.getGenre.data;

  const [updateArtistProfile] = useMutation(UPDATE_USER, {
    variables: {},
    onError(err) {
      loaderMutate({ variables: { show: false } });
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },

    onCompleted() {
      loaderMutate({ variables: { show: false } });
      updateUserList && updateUserList();
    },
  });
  const toggle = () => {
    setModal(!modal);
    onClose();
  };
  const hideModal = () => {
    toggle();
    props.onClose();
  };

  const {
    data: userApiData,
  } = useQuery(
    GET_USER_DATA_QUERY, {
      variables: { userId },
      fetchPolicy: 'network-only',
    },
  );

  const {
    data: apiAssociatedData,
  } = useQuery(
    GET_ASSOCIATED_DATA_QUERY, {
      variables: { artistId: userId },
    },
  );

  useEffect(() => {
    if (userApiData) {
      const { data } = userApiData.getUser;
      if (data.socialMedia) {
        Object.keys(data.socialMedia).forEach((k) => {
          data.socialMedia[k] = data.socialMedia[k] !== '' && !data.socialMedia[k].includes('http') ? `https://${data.socialMedia[k]}` : data.socialMedia[k];
        });
      }
      setUserData({ ...data });
    }
  }, [userApiData]);

  const hideModalPopup = (modalType) => {
    (modalType === staticConstants.MODAL_POPUP_TYPE.DEACTIVATED) && setDeactivateModal(false);
    (modalType === staticConstants.MODAL_POPUP_TYPE.EDIT_PROFILE) && setEditArtistModal(false);
  };

  const showModalPopup = (modalType) => {
    if (modalType === staticConstants.MODAL_POPUP_TYPE.DEACTIVATED) {
      setDeactivateModal(true);
      setModal(false);
      userData.status = isCurrentUserDeactive
        ? staticConstants.MODAL_POPUP_TYPE.DEACTIVATED
        : staticConstants.MODAL_POPUP_TYPE.ACTIVE;
    } else if (modalType === staticConstants.MODAL_POPUP_TYPE.EDIT_PROFILE) {
      setEditArtistModal(true);
      setModal(false);
    }
  };

  useEffect(() => {
    if (userData && userData.note) {
      setNoteValue(userData.note);
      setDefaultNoteValue(userData.note);
    }
  }, [userData]);

  const onSubmit = () => {
    updateArtistProfile({ variables: { userId: userData._id, note: noteValue } });
    setDefaultNoteValue(noteValue);
  };

  const handleClearInput = () => {
    setNoteValue('');
  };

  const openNotePopup = () => {
    setNoteValue(defaultNoteValue);
  };

  const updateIsEditDemoGraph = (value) => {
    setIsEditDemoGraph(value);
  };

  const renderGenreData = () => {
    return map(userData.genre, (genre, index) => {
      const genreFind = genreData.find((el) => el._id === genre);
      if(genreFind) {
        return (
          <span key={index.toString()}>
            {genreFind.name}
          </span>
        );
      }
    })
  }

  const downloadGraph = (userName) => {
    const targetComponent = targetref.current;
    html2canvas(targetComponent, {
      allowTaint: false, useCORS: true, scrollY: 0, scrollX: 0,
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new JsPDF('p', 'pt', 'a4');
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${capitalizeEveryWord(userName)}-Demograph.pdf`);
    });
  };

  const checkGraphExist = (graphData) => {
    setIsDemoGraphExist(graphData.hasData);
    setGraphLastUpdatedAt(graphData.lastUpdatedAt);
  };

  const userDetailImg = `${userData.artistImage}?${Math.random()}`;

  return userData && (
    <>
      <Modal isOpen={modal} className="modal-artist-detail modal-full-w">
        <ModalBody>
          <span
            onClick={hideModal}
            className="icon icon-cross"
          />
          {
            (isDemoGraphExist && !isEditDemoGraph)
            && (
              <Button
                onClick={() => downloadGraph(userData.name)}
                color="fade"
                className="download-demograph-btn"
              >
                Download demographics
              </Button>
            )
          }
          <div className="demograph-modal-wrapper" ref={targetref}>
            <div className="modal-artist-detail-wrapper">
              <div className="modal-artist-detail-bio">
                <span>
                  <img
                    src={userDetailImg || FALLBACK_ICON}
                    className="image-cover"
                    alt="User"
                    crossOrigin="anonymous"
                  />
                </span>
                <div className="modal-artist-detail-content">
                  <p className="text-truncate">
                    <em className="ico icon-icon-location address-small-icon" />
                    {userData.city
                      ? `${`${capitalizeEveryWord(`${userData.city.label}`)}, `}`
                      : ''}
                    {userData.state
                      ? `${`${capitalizeEveryWord(`${userData.state.label}`)}, `}`
                      : ''}
                    {userData.country
                      ? capitalizeEveryWord(`${userData.country.label}`)
                      : ''}
                  </p>
                  <h4>
                    {' '}
                    {capitalizeEveryWord(`${userData.name}`) || ''}
                    {' '}
                    <UncontrolledButtonDropdown className="note-dropdown-toggle" data-html2canvas-ignore="true">
                      <DropdownToggle>
                        <em
                          className={`note-icon ${userData.note || defaultNoteValue ? 'yellow-card' : 'gray-card'}`}
                          onClick={() => openNotePopup()}
                        />
                      </DropdownToggle>
                      <DropdownMenu right className="dropdown-theme note-dropdown">
                        <div className="dropdown-header">
                          Note for admin
                          <DropdownItem>
                            <span className="icon icon-cross" />
                          </DropdownItem>
                        </div>
                        <Input
                          type="textarea"
                          className="medium"
                          name="note"
                          maxLength={500}
                          value={noteValue}
                          onChange={(e) => setNoteValue(e.target.value)}
                        />
                        <div className="dropdown-footer">
                          <span onClick={() => handleClearInput()}>Clear</span>
                          <DropdownItem
                            className="btn btn-save"
                            onClick={() => onSubmit()}
                          >
                            Save
                          </DropdownItem>
                        </div>
                      </DropdownMenu>
                    </UncontrolledButtonDropdown>
                  </h4>
                  <em>
                    {
                      userData.managerData && userData.managerData.managerFirstName
                      && <span>Label:</span>
                    }
                    {userData.managerData
                      ? capitalizeEveryWord(`${userData.managerData.managerFirstName} ${userData.managerData.managerLastName}`)
                      : ''}

                  </em>
                  {canEdit && (
                    <UncontrolledButtonDropdown className="action-dropdown-toggle artist-detail-action-toggle" data-html2canvas-ignore="true">
                      <DropdownToggle>
                        <div className="modal-toggle" />
                      </DropdownToggle>
                      <DropdownMenu right className="dropdown-theme action-dropdown">
                        {
                          !isCurrentUserDeactive
                          && (
                            <>
                              <DropdownItem onClick={() => showModalPopup(staticConstants.MODAL_POPUP_TYPE.EDIT_PROFILE)}>
                                Update Artist Info
                              </DropdownItem>
                              {isDemoGraphExist && !isEditDemoGraph && (
                                <DropdownItem onClick={() => setIsEditDemoGraph(true)}>
                                  Edit Demographics
                                </DropdownItem>
                              )}
                            </>
                          )
                        }
                        <DropdownItem
                          className={`${!isCurrentUserDeactive ? 'item-text-red' : ''}`}
                          onClick={() => showModalPopup(staticConstants.MODAL_POPUP_TYPE.DEACTIVATED)}
                        >
                          {isCurrentUserDeactive
                            ? 'Activate account' : 'Deactivate account'}
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledButtonDropdown>
                  )}
                </div>
              </div>
              <div className="modal-artist-detail-info no-ellipses">
                <p>
                  <span className="ico icon-phone" />
                  {userData.contactNumber || ''}
                </p>
                <p>
                  <span className="ico icon-email" />
                  {userData.email || (userData.managerId && userData.managerId.email)}
                </p>
                {
                  userData?.shippingAddress
                  && (
                  <p className="address-icon-container">
                    <span className="ico icon-icon-location" />
                    {`Shipping address`}
                    <p class="new-line-wrap">{userData.shippingAddress}</p>
                  </p>
                  )
                }
              </div>
              <div className="modal-artist-detail-tag-info">
                <div className="tags-wrap">
                  {genreData && renderGenreData()}
                </div>
                <p className="new-line-wrap">{capitalizeEveryWord(userData.bio)}</p>
              </div>
              <>
                {
                  apiAssociatedData && apiAssociatedData.associatedOffer

                  && (
                    <AssocoatedOffers
                      associatedData={apiAssociatedData.associatedOffer}
                      revenue={userData.totalRevenue}
                      totalOffer={userData.totalOffer}
                      canNavToOffer={canNavToOffer}
                    />
                  )
                }
              </>
            </div>
            {userData.socialMedia && (
              <div className="modal-artist-detail-demographics">
                <div className="modal-artist-detail-demographics-social-icons" data-html2canvas-ignore="true">
                  {userData.socialMedia.facebook
                    && <a className="social-icon facebook" href={userData.socialMedia.facebook} target="_blank" rel="noopener noreferrer" />}
                  {userData.socialMedia.twitter
                    && <a className="social-icon twitter" href={userData.socialMedia.twitter} target="_blank" rel="noopener noreferrer" />}
                  {userData.socialMedia.youtube
                    && <a className="social-icon youtube" href={userData.socialMedia.youtube} target="_blank" rel="noopener noreferrer" />}
                  {userData.socialMedia.instagram
                    && <a className="social-icon instagram" href={userData.socialMedia.instagram} target="_blank" rel="noopener noreferrer" />}
                  {userData.socialMedia.spotify
                    && <a className="social-icon spotify" href={userData.socialMedia.spotify} target="_blank" rel="noopener noreferrer" />}
                  {userData.socialMedia.weblink
                    && <a className="social-icon weblink" href={userData.socialMedia.weblink} target="_blank" rel="noopener noreferrer" />}
                  {(isDemoGraphExist && !isEditDemoGraph)
                    && (
                      <span className="last-updated-date">{`Last updated on ${moment(graphLastUpdatedAt).format(dateFormats.DATE_WITH_YEAR)}`}</span>
                    )}
                </div>

                {userData
                  && (
                    <Demographics
                      checkGraphHasData={checkGraphExist}
                      artistId={userData._id}
                      isEditDemoGraph={isEditDemoGraph}
                      categories={userData.category}
                      updateIsEditDemoGraph={updateIsEditDemoGraph}
                      isCurrentUserDeactive={isCurrentUserDeactive}
                    />
                  )}
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>

      {(deactivateModal && userData) && (
        <Deactivate
          isOpen={deactivateModal}
          onClose={() => hideModalPopup(staticConstants.MODAL_POPUP_TYPE.DEACTIVATED)}
          userDetail={userData}
          role={staticConstants.ROLE_TYPE.ARTIST}
          updateUserList={updateUserList}
        />
      )}
      {(editArtistModal && userData) && (
        <EditProfileDetail
          isOpen={editArtistModal}
          userId={userData._id}
          userRole={staticConstants.ROLE.ARTIST}
          onClose={() => hideModalPopup(staticConstants.MODAL_POPUP_TYPE.EDIT_PROFILE)}
          updateUserList={updateUserList}
        />
      )}
    </>
  );
}

ArtistDetail.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  updateUserList: PropTypes.func,
  userId: PropTypes.string.isRequired,
  canEdit: PropTypes.bool,
  isCurrentUserDeactive: PropTypes.bool,
  canNavToOffer: PropTypes.bool,
};

ArtistDetail.defaultProps = {
  updateUserList: null,
  canEdit: true,
  isCurrentUserDeactive: false,
  canNavToOffer: true,
};

export default ArtistDetail;
